import { theme } from '@/utils/theme';

export const classes = {
  paper: 'flex',
};

export const styles = {
  iconButton: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  calendar: {
    '& .MuiPickersDay-today:not(.Mui-selected)': {
      border: `1px solid ${theme.palette['grey-5'].main}`,
    },
    '& .MuiPickersDay-root:focus.Mui-selected, & .MuiPickersDay-root.Mui-selected, & .MuiPickersDay-root.Mui-selected:hover':
      {
        backgroundColor: theme.palette['brand-green'].main,
        color: theme.palette['grey-6'].main,
      },
  },
};
